import { FgtsSlider } from '@itau-loans-www/components'

import './fgts-slider-section.scss'

const carouselConfig = {
  slidesToShow: 4,
  slidesToScroll: 1,
  infinite: false,
  lazyLoad: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        infinite: false,
        slidesToShow: 2.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 576,
      settings: {
        infinite: false,
        slidesToShow: 1.25,
        slidesToScroll: 1
      }
    }
  ]
}

const FgtsSliderSection = ({ content }) => {
  const { list = [], title = '' } = content

  return (
    <section className="fgts-slider-section">
      <div className="container">
        <h3 className="fgts-slider-section__title">{title}</h3>
      </div>
      <div className="container">
        <FgtsSlider slides={list} config={carouselConfig} />
      </div>
    </section>
  )
}

export default FgtsSliderSection
